import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37cc1579"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "stake-nominate__item-block" }
const _hoisted_3 = { class: "stake-nominate__item-info" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "stake-nominate__item-info-block" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "over"
}
const _hoisted_9 = { class: "stake-nominate__item-block" }
const _hoisted_10 = { class: "stake-nominate__item-block" }
const _hoisted_11 = { class: "stake-nominate__item-block" }
const _hoisted_12 = { class: "stake-nominate__item-block" }

import { computed, ref, PropType } from "vue";
import BaseCheckbox from "@/components/base-checkbox/index.vue";
import InfoTooltip from "@/components/info-tooltip/index.vue";
import { Validator } from "@/types/staking";

const overInfo =
  "Oversubscribed info will be credited to your bonded balance for compound earning.";


export default /*#__PURE__*/_defineComponent({
  __name: 'stake-nominate-item',
  props: {
  amountToStake: { type: Number, default: 0 },
  validator: {
    type: Object as PropType<Validator>,
    default: null,
  },
  yield: { type: Number, default: 0 },
},
  emits: ["update:selectValidator", "update:deleteValidator"],
  setup(__props, { emit }) {

const props = __props;

const isSelect = ref<boolean>(false);




const estimatedReturn = computed(() => {
  return (
    props.amountToStake * props.yield * (1 - props.validator.commission / 100)
  );
});

const selectValidator = () => {
  emit("update:selectValidator", props.validator);
};

const deleteValidator = () => {
  emit("update:deleteValidator", props.validator);
};

const toggleSelect = () => {
  isSelect.value = !isSelect.value;

  if (isSelect.value) {
    selectValidator();
  } else {
    deleteValidator();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "stake-nominate__item",
    onClick: _withModifiers(toggleSelect, ["stop"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: __props.validator.image,
          alt: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", null, [
            _createTextVNode(_toDisplayString(__props.validator.name
                ? __props.validator.name
                : _ctx.$filters.replaceWithEllipsis(__props.validator.address, 6, 6)) + " ", 1),
            (__props.validator.isHighRisk)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "High risk"))
              : _createCommentVNode("", true)
          ]),
          (!__props.validator.isOversubscribed)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.validator.nominators) + " nominators ", 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _createTextVNode(" Oversubscribed " + _toDisplayString(__props.validator.nominators) + " ", 1),
                _createVNode(InfoTooltip, { text: overInfo })
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("span", null, _toDisplayString(__props.validator.commission.toFixed(2)) + "%", 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.validator.total || 0)) + " DOT", 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.cryptoCurrencyFormat(estimatedReturn.value || 0)) + " DOT", 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(BaseCheckbox, {
        class: "hardware-select-account__checkbox",
        "is-checked": isSelect.value,
        disabled: false,
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, null, 8, ["is-checked"])
    ])
  ], 8, _hoisted_1))
}
}

})